/** Не-компонентные помощники UI (классы, текст ошибки API). */
import { extractErrorMessage } from "@/lib/api-errors";

/** Текст ошибки API с понятной причиной по статусу (503 — витрина/DWH, 422 — параметры);
 *  `mpLabel` — площадка («Ozon», «WB») для текста 503. */
export function apiErrorText(err: unknown, mpLabel: string): string {
  const status = (err as { response?: { status?: number } })?.response?.status;
  const detail = extractErrorMessage(err, "ошибка запроса");
  if (status === 503) return `Витрина ${mpLabel} недоступна (503): ${detail}`;
  if (status === 422) return `Неверные параметры (422): ${detail}`;
  if (status === 403) return `Нет доступа (403): ${detail}`;
  if (status === 404) return `Не найдено (404): ${detail}`;
  return status ? `Ошибка ${status}: ${detail}` : `Ошибка: ${detail}`;
}

export const selectClass = "h-8 rounded-md border bg-background px-2 text-xs";

/** Значение со знаком витрины: отрицательное — красным (удержания). */
export function moneyClass(v: number): string {
  return v < -0.5 ? "text-red-600 dark:text-red-400" : "";
}

/** Шапка таблицы — компактный стиль как в orders. */
export const thClass =
  "px-2 py-1.5 text-right text-[11px] font-medium uppercase tracking-wide text-muted-foreground whitespace-nowrap";
export const tdNum = "px-2 py-1 text-right tabular-nums whitespace-nowrap";
